/**
 * donation-form — unique field-id generator. SYNC: see ../_SYNC.md. Pure.
 *
 * A module-scoped monotonic counter yields a stable, unique id per call so a
 * <label :for> can target its slotted control (WCAG 2.1 AA label association).
 * Vue 3.5's `useId` is not relied on (the host pins Vue 3.4).
 */
let counter = 0;
export function nextFieldId(prefix = "df-field") {
    counter += 1;
    return `${prefix}-${counter}`;
}
